(function(){
"use strict";
function byId(id){
return document.getElementById(id);
}function clean(v){
return String(v||"").replace(/\s+/g," ").trim();
}function labelForCategory(id){
var map={
popular:"🔥 Popular",coffee:"☕ Coffee",food:"🍔 Food",food_iq:"🍔 Food IQ",bbq:"🍖 BBQ",golf:"🏌️ Golf",scenic:"🌅 Scenic",local_favorites:"🏆 Local Faves",live_music:"🎶 Live Music",hidden_gems:"💎 Hidden Gems",waterfront:"🌊 Water",water:"🌊 Water",outdoors:"🥾 Outdoors",shopping:"🛍 Shopping",family:"👨‍👩‍👧 Family",dog_friendly:"🐶 Dog Friendly",nightlife:"🍹 Nightlife",gameday:"🏈 Gameday",lake_iq:"🚤 Lake IQ"
};
return map[id]||clean(id).replace(/_/g," ");
}function waitForDriveIQ(cb){
var tries=0;
var timer=window.setInterval(function(){
tries+=1;
if(window.DriveIQ&&window.DriveIQ.Personalization){
window.clearInterval(timer);
cb();
}else if(tries>40){
window.clearInterval(timer);
cb();
}
},100);
}function animateNumber(el,target){
var start=0;
var end=Number(target||0);
var started=Date.now();
var duration=650;
if(!el){
return;
}if(!end){
el.textContent="0";
return;
}function tick(){
var p=(Date.now()-started)/duration;
var v;
if(p>1){
p=1;
}v=Math.round(start+(end-start)*(1-Math.pow(1-p,3)));
el.textContent=String(v);
if(p<1){
window.requestAnimationFrame(tick);
}
}tick();
}function levelFromPassport(passport){
var places=Number(passport.placesExplored||0);
var worth=Number(passport.worthTheDrive||0);
var hidden=Number(passport.hiddenGems||0);
var score=places+worth*2+hidden*3;
if(score>=450){
return{
level:9,name:"Legend"
};
}if(score>=280){
return{
level:7,name:"Neighborhood Insider"
};
}if(score>=160){
return{
level:5,name:"Adventure Hunter"
};
}if(score>=80){
return{
level:4,name:"Road Warrior"
};
}if(score>=35){
return{
level:3,name:"Local Expert"
};
}if(score>=10){
return{
level:2,name:"Explorer"
};
}return{
level:1,name:"Explorer"
};
}function iconForCollection(name){
var n=String(name||"").toLowerCase();
if(n.indexOf("coffee")>-1){
return"☕";
}if(n.indexOf("golf")>-1){
return"🏌️";
}if(n.indexOf("patio")>-1||n.indexOf("sun")>-1){
return"☀️";
}if(n.indexOf("food")>-1||n.indexOf("bbq")>-1){
return"🍔";
}if(n.indexOf("music")>-1){
return"🎵";
}return"⭐";
}function rotateHeroCopy(){
return;
}function renderToday(passport){
var grid=byId("mdiTodayGrid");
var places=Number(passport.placesExplored||0);
var worth=Number(passport.worthTheDrive||0);
var hidden=Number(passport.hiddenGems||0);
var lines;
if(!grid){
return;
}lines=["☀️ <span><strong>Patio weather:</strong> check Adventure IQ before dinner</span>","☕ <span><strong>Coffee IQ:</strong> local picks can match your taste</span>","🎵 <span><strong>Tonight:</strong> live music and nightlife scans are ready</span>","📍 <span><strong>Nearby:</strong> "+(places>0?String(places)+" places are shaping your local guide":"Drive IQ is learning your favorite zones")+"</span>"];
if(worth>0){
lines[0]="⭐ <span><strong>Worth the Drive:</strong> "+String(worth)+" strong stop"+(worth===1?"":"s")+" already in your profile</span>";
}if(hidden>0){
lines[2]="💎 <span><strong>Hidden Gems:</strong> "+String(hidden)+" discovery signal"+(hidden===1?"":"s")+" in your Journey Passport</span>";
}grid.innerHTML='<div class="mdiTodayItem">'+lines[0]+'</div><div class="mdiTodayItem">'+lines[1]+'</div><div class="mdiTodayItem">'+lines[2]+'</div><div class="mdiTodayItem">'+lines[3]+'</div>';
}function mdiCompletedDriveCount(){
var n=0;
try{
n=Number(localStorage.getItem("diq_completed_trips_v1")||0);
}catch(e){
n=0;
}if(!isFinite(n)||n<0){
n=0;
}return Math.floor(n);
}function render(){
var p=null;
var passport={
};
var pinned=["coffee","golf","bbq","scenic","live_music"];
var taste=[];
var collections=[];
var neighborhoods=[];
var level;
var i;
var el;
var html="";
try{
if(window.DriveIQ&&window.DriveIQ.Personalization){
p=window.DriveIQ.Personalization.load();
passport=window.DriveIQ.Personalization.getPassport()||{
};
pinned=window.DriveIQ.Personalization.getPinnedCategories()||pinned;
taste=window.DriveIQ.Personalization.getTopTaste(5)||[];
collections=window.DriveIQ.Personalization.getCollections()||[];
neighborhoods=window.DriveIQ.Personalization.getNeighborhoods()||[];
}
}catch(e){
}passport=passport||{
};
passport.placesExplored=Math.max(Number(passport.placesExplored||0),mdiCompletedDriveCount());
animateNumber(byId("mdiPlaces"),passport.placesExplored||0);
animateNumber(byId("mdiWorth"),passport.worthTheDrive||0);
animateNumber(byId("mdiHidden"),passport.hiddenGems||0);
animateNumber(byId("mdiStates"),(passport.states&&passport.states.length)||0);
level=levelFromPassport(passport);
if(byId("mdiLevelName")){
byId("mdiLevelName").textContent=level.name;
}if(byId("mdiLevelBadge")){
byId("mdiLevelBadge").textContent="Level "+String(level.level);
}if(byId("mdiXpText")){
byId("mdiXpText").textContent=String((Number(passport.placesExplored||0)+Number(passport.worthTheDrive||0)*2+Number(passport.hiddenGems||0)*3)||0)+" XP";
}if(byId("mdiXpFill")){
var xp=(Number(passport.placesExplored||0)+Number(passport.worthTheDrive||0)*2+Number(passport.hiddenGems||0)*3)||0;
byId("mdiXpFill").style.width=String(Math.max(12,Math.min(96,(xp%120)/120*100)))+"%";
}renderToday(passport);
el=byId("mdiAdventurePills");
if(el){
html="";
for(i=0;
i<pinned.length;
i++){
html+='<span class="mdiPill '+(i===0?'hot':'')+'">'+labelForCategory(pinned[i])+'</span>';
}el.innerHTML=html||'<span class="mdiPill hot">☕ Coffee</span><span class="mdiPill">🏌️ Golf</span><span class="mdiPill">🍔 BBQ</span>';
}el=byId("mdiTastePills");
if(el&&taste.length){
html="";
for(i=0;
i<taste.length;
i++){
if(Number(taste[i].score||0)<=0){
continue;
}html+='<span class="mdiPill '+(i===0?'hot':'')+'">'+labelForCategory(taste[i].key)+'</span>';
}if(html){
el.innerHTML=html;
}
}el=byId("mdiCollections");
if(el&&collections.length){
html="";
for(i=0;
i<collections.length;
i++){
html+='<div class="mdiListItem"><div class="mdiListMain"><div class="mdiListIcon">'+iconForCollection(collections[i].name)+'</div><div><strong>'+clean(collections[i].name||"Collection")+'</strong><small>Collection</small></div></div><span>'+String((collections[i].places&&collections[i].places.length)||0)+' places</span></div>';
}el.innerHTML=html;
}el=byId("mdiNeighborhoods");
if(el&&neighborhoods.length){
html="";
for(i=0;
i<neighborhoods.length;
i++){
html+='<div class="mdiListItem"><div class="mdiListMain"><div class="mdiListIcon">📍</div><div><strong>'+clean(neighborhoods[i].name||"Place")+'</strong><small>Neighborhood IQ</small></div></div><span>'+String(neighborhoods[i].visits||1)+' visits</span></div>';
}el.innerHTML=html;
}syncThemes();
}/* Garage V2: Garage selection remains authoritative here;
native CarPlay sync is handled separately by the iOS bridge. */var DIQ_SKIN_KEYS=["diq_active_skin_v1","diq_native_active_skin_v1","driveiq_skin","driveiq_theme","diq_theme_v1"];
var DIQ_SKIN_ALLOW={
carbon_rs:1,american_muscle:1,platinum_gt:1,cockpit:1,aurora:1,sunset:1,coastal:1,
midnight_luxe:1,volt:1,forest:1,autumn:1,holiday:1
};
// The older theme-renderer.js may not recognize Carbon RS.
// Garage keeps its own preference instead of letting legacy fallback overwrite it.
var DIQ_GARAGE_KEY="diq_garage_skin_v1";
var mdiSkinApplying=false;
var mdiLastSkin="";
var mdiThemeSelectionRevision=0;
function mdiNormalizeSkin(v){
v=clean(v).toLowerCase().replace(/[\s-]+/g,"_");
if(v==="midnight"||v==="midnightluxe"||v==="midnight_luxury")v="midnight_luxe";
if(v==="volt_gt"||v==="voltgt")v="volt";
if(v==="americanmuscle"||v==="muscle"||v==="muscle_gt")v="american_muscle";
if(v==="carbonrs"||v==="carbon_rs_silver")v="carbon_rs";
return DIQ_SKIN_ALLOW[v]?v:"cockpit";
}
function mdiWriteSkinCookie(skin){
try{document.cookie="diq_active_skin_v1="+encodeURIComponent(skin)+"; path=/; max-age=31536000; SameSite=Lax";}catch(e){}
}
function mdiApplySkinDom(skin){
skin=mdiNormalizeSkin(skin);
var page=byId("myDriveIQPage");
if(page)page.setAttribute("data-diq-skin",skin);
if(document.documentElement)document.documentElement.setAttribute("data-diq-skin",skin);
if(document.body)document.body.setAttribute("data-diq-skin",skin);
}
function mdiGetActiveSkin(){
var current="";
try{
current=localStorage.getItem(DIQ_GARAGE_KEY)||"";
if(!current){
for(var i=0;i<DIQ_SKIN_KEYS.length;i++){
current=localStorage.getItem(DIQ_SKIN_KEYS[i])||"";
if(current)break;
}
}
}catch(e){}
return mdiNormalizeSkin(current||"cockpit");
}
function mdiPersistSkin(skin){
try{
localStorage.setItem(DIQ_GARAGE_KEY,skin);
for(var i=0;i<DIQ_SKIN_KEYS.length;i++)localStorage.setItem(DIQ_SKIN_KEYS[i],skin);
}catch(e){}
mdiWriteSkinCookie(skin);
mdiApplySkinDom(skin);
window.DriveIQActiveSkin=skin;
}
function mdiApplySkinAuthority(skin,source){
skin=mdiNormalizeSkin(skin);
if(mdiSkinApplying)return;
mdiSkinApplying=true;
var selectionRevision=++mdiThemeSelectionRevision;
try{
// Persist the selected Garage ID. Keep the existing IDs for native CarPlay.
mdiPersistSkin(skin);
// Some signature cockpits are not recognized by older theme-renderer.js versions.
// Do not let legacy fallback overwrite Carbon RS, American Muscle or Platinum GT.
if(skin!=="carbon_rs" && skin!=="american_muscle" && skin!=="platinum_gt"){
try{
if(window.DriveIQ&&typeof window.DriveIQ.applyTheme==="function"){
window.DriveIQ.applyTheme(skin);
}
}catch(e){}
}
// Reassert Garage authority if a legacy renderer changed its shared keys.
mdiPersistSkin(skin);
mdiLastSkin=skin;
syncThemes();
// ALWAYS announce selections, including Carbon RS, for the native theme bridge.
try{
window.dispatchEvent(new CustomEvent("driveiq:themechange",{
detail:{theme:skin,skin:skin,source:source||"myiq"}
}));
}catch(e){}
// External theme listeners can write an older skin during dispatch. Reassert
// the explicit user choice after they finish, without firing another event.
mdiPersistSkin(skin);
syncThemes();
// Some legacy listeners repaint on the next tick. Repair just this selection;
// cancel any pending repairs when the user taps a different theme.
[0,150,500].forEach(function(delay){
window.setTimeout(function(){
if(selectionRevision!==mdiThemeSelectionRevision)return;
try{
var stored=localStorage.getItem(DIQ_GARAGE_KEY)||"";
var active=localStorage.getItem("diq_active_skin_v1")||"";
var dom=byId("myDriveIQPage");
if(stored!==skin||active!==skin||(dom&&dom.getAttribute("data-diq-skin")!==skin)){
mdiPersistSkin(skin);
syncThemes();
}
}catch(e){}
},delay);
});
}finally{
// Guard synchronous listeners; do not lock out the next user tap.
mdiSkinApplying=false;
}
}
function syncThemes(){
var current=mdiGetActiveSkin();
mdiApplySkinDom(current);
var buttons=document.querySelectorAll("#mdiThemeGrid .mdiThemeCard[data-theme]");
for(var i=0;i<buttons.length;i++){
var selected=buttons[i].getAttribute("data-theme")===current;
buttons[i].classList.toggle("on",selected);
buttons[i].setAttribute("aria-pressed",selected?"true":"false");
}
}
function exposeSkinBridge(){
// Reconcile old Midnight Luxe values only on the Garage page, where its saved selection is authoritative.
mdiPersistSkin(mdiGetActiveSkin());
window.DriveIQSkinBridge={
get:mdiGetActiveSkin,
set:function(s){mdiApplySkinAuthority(s,"bridge");},
apply:function(s){mdiApplySkinDom(s||mdiGetActiveSkin());},
keys:[DIQ_GARAGE_KEY].concat(DIQ_SKIN_KEYS)
};
window.DriveIQActiveSkin=mdiGetActiveSkin();
}
function bindThemes(){
var grid=byId("mdiThemeGrid");
if(!grid)return;
grid.addEventListener("click",function(e){
var target=e.target.closest?e.target.closest("[data-theme]"):null;
if(target&&grid.contains(target)&&!target.disabled&&target.getAttribute("aria-disabled")!=="true")
mdiApplySkinAuthority(target.getAttribute("data-theme"),"myiq-theme-tap");
});
}
function mdiNormalizeMarker(v){
var a={
rocket_scout:1,turbo_bolt:1,falcon_wing:1,compass_star:1,rally_rider:1,trail_beast:1
};
v=clean(v).toLowerCase().replace(/[\s-]+/g,"_");
return a[v]?v:"rocket_scout";
}function mdiGetVehicleMarker(){
var v="rocket_scout";
try{
v=localStorage.getItem("diq_vehicle_marker_v1")||v;
}catch(e){
}return mdiNormalizeMarker(v);
}function syncMarkers(){
var current=mdiGetVehicleMarker();
var buttons=document.querySelectorAll?document.querySelectorAll(".mdiMarkerCard"):[];
var i;
for(i=0;
i<buttons.length;
i++){
buttons[i].className=buttons[i].getAttribute("data-marker")===current?"mdiMarkerCard on":"mdiMarkerCard";
}try{
window.DriveIQVehicleMarker=current;
}catch(e){
}
}function mdiSetVehicleMarker(v){
v=mdiNormalizeMarker(v);
try{
localStorage.removeItem("diq_vehicle_3d_type_v1");
localStorage.removeItem("diq_vehicle_3d_color_v1");
localStorage.removeItem("diq_vehicle_3d_url_v1");
localStorage.setItem("diq_vehicle_marker_v1",v);
}catch(e){
}syncMarkers();
try{
window.dispatchEvent(new CustomEvent("driveiq:markerchange",{
detail:{
marker:v,source:"myiq"
}
}));
}catch(e2){
}
}function bindMarkers(){
var grid=byId("mdiMarkerGrid");
if(!grid){
return;
}grid.onclick=function(e){
var t=e.target;
while(t&&t!==grid){
if(t.getAttribute&&t.getAttribute("data-marker")){
mdiSetVehicleMarker(t.getAttribute("data-marker"));
return;
}t=t.parentNode;
}
};
}function mdiGetVoiceStyle(){
var v="calm";
try{
v=localStorage.getItem("diq_voice_style_v1")||v;
}catch(e){
}return clean(v)||"calm";
}function mdiSetVoiceStyle(v){
v=clean(v)||"calm";
try{
localStorage.setItem("diq_voice_style_v1",v);
}catch(e){
}try{
window.dispatchEvent(new CustomEvent("diqVoiceChanged",{
detail:{
voice:v,source:"myiq"
}
}));
}catch(e2){
}syncVoice();
}function ensureVoiceCard(){
var themeCard=byId("mdiThemeGrid");
var card;
if(byId("mdiVoiceGrid")){
return;
}if(!themeCard||!themeCard.parentNode){
return;
}card=document.createElement("section");
card.className="mdiCard";
card.innerHTML='<div class="mdiCardHead"><div><div class="mdiCardTitle">🎙 Voice IQ</div><div class="mdiCardSub">Choose how Drive IQ talks. Timing, street names, and maneuver truth always stay first.</div></div></div><div class="mdiVoiceGrid" id="mdiVoiceGrid"><button class="mdiVoiceCard" type="button" data-voice="calm"><strong>Calm Navigator</strong><span>Clear and steady</span></button><button class="mdiVoiceCard" type="button" data-voice="friendly"><strong>Friendly Co-Pilot</strong><span>Warm and helpful</span></button><button class="mdiVoiceCard" type="button" data-voice="southern"><strong>Southern Comfort</strong><span>Local and easygoing</span></button><button class="mdiVoiceCard" type="button" data-voice="minimal"><strong>Minimal Driver</strong><span>Short and direct</span></button><button class="mdiVoiceCard" type="button" data-voice="detailed"><strong>Detailed Guide</strong><span>Extra context</span></button><button class="mdiVoiceCard" type="button" data-voice="professional"><strong>Professional</strong><span>Polished and precise</span></button></div>';
try{
themeCard.parentNode.parentNode.insertBefore(card,themeCard.parentNode.nextSibling);
}catch(e){
}
}function syncVoice(){
var current=mdiGetVoiceStyle();
var buttons=document.querySelectorAll?document.querySelectorAll(".mdiVoiceCard"):[];
var i;
for(i=0;
i<buttons.length;
i++){
if(buttons[i].getAttribute("data-voice")===current){
buttons[i].className="mdiVoiceCard on";
}else{
buttons[i].className="mdiVoiceCard";
}
}
}function bindVoice(){
var grid=byId("mdiVoiceGrid");
if(!grid){
return;
}grid.onclick=function(e){
var t=e.target;
while(t&&t!==grid){
if(t.getAttribute&&t.getAttribute("data-voice")){
mdiSetVoiceStyle(t.getAttribute("data-voice"));
return;
}t=t.parentNode;
}
};
}function bindBack(){
var back=document.querySelector?document.querySelector(".mdiBack"):null;
if(!back)return;
// Always navigate on the CURRENT origin. Never replay browser history,
// which can lead to a cached page or the alternate Shopify domain.
back.setAttribute("href","/");
back.onclick=function(e){
if(e){e.preventDefault();}
window.location.assign("/");
return false;
};
}function mdiHasActiveRoute(){
// Do not bypass Start Drive unless there is a live, usable route session.
try{
if(localStorage.getItem("diq_drive_on_v1")!=="1")return false;
if(!localStorage.getItem("diq_active_drive_id_v1"))return false;
var raw=localStorage.getItem("diq_route_geo_v1");
var geo=raw?JSON.parse(raw):null;
if(geo&&geo.features&&geo.features.length>0)return true;
raw=localStorage.getItem("diq_drive_payload_v1");
var payload=raw?JSON.parse(raw):null;
return !!(payload&&payload.route&&payload.route.features&&payload.route.features.length>0);
}catch(e){return false;}
}function installGoDriveShortcut(){
var back=document.querySelector?document.querySelector(".mdiBack"):null;
if(!back||!back.parentNode||byId("mdiGoDriveShortcut"))return;
var wrapper=document.createElement("div");
wrapper.className="mdiTopNavActions";
wrapper.style.cssText="display:flex;align-items:center;justify-content:space-between;gap:10px;width:100%;margin:42px 0 14px;min-height:44px;position:relative;z-index:9999;";
back.parentNode.insertBefore(wrapper,back);
wrapper.appendChild(back);
back.style.cssText="margin:0!important;min-height:44px;padding:0 4px!important;gap:2px;display:inline-flex;align-items:center;white-space:nowrap;";
var go=document.createElement("a");
go.id="mdiGoDriveShortcut";
go.href="/pages/start-drive";
go.textContent="Go Drive  →";
go.setAttribute("aria-label","Go to driving navigation");
go.style.cssText="flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;min-height:44px;padding:0 14px;border-radius:999px;background:rgba(219,226,235,.09);border:1px solid rgba(219,226,235,.32);color:#f1f4f8!important;font:750 12px/1 system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,sans-serif;letter-spacing:.25px;text-decoration:none!important;white-space:nowrap;box-shadow:none;-webkit-tap-highlight-color:transparent;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);";
wrapper.appendChild(go);
go.addEventListener("click",function(e){
if(e)e.preventDefault();
// Canonical same-origin paths, never an absolute Shopify host.
var destination=mdiHasActiveRoute()?"/pages/drive-mode":"/pages/start-drive";
window.location.assign(destination);
},false);
}function mdiRenderTier(){
var n=mdiCompletedDriveCount(),plus=false,badge=byId("mdiTierBadge"),summary=byId("mdiTierSummary"),btn=byId("mdiTierUpgrade");
try{
plus=localStorage.getItem("diq_plus_active_v1")==="1"||localStorage.getItem("diq_founding_driver_v1")==="1";
}catch(e){
}if(badge){
badge.textContent=plus?"DRIVE IQ PLUS":(n<5?"FULL-FEATURE TRIPS":"DRIVE IQ FREE");
}if(summary){
summary.textContent=plus?"Plus is active. Your premium features are available.":(n<5?(5-n)+" of your first five full-feature trips remaining. Basic navigation stays free afterward.":"Your first five full-feature trips are complete. Basic GPS navigation, voice directions and rerouting remain free.");
}if(btn){
btn.style.display=plus?"none":"inline-block";
}
}function mdiPremiumLocked(){
var n=mdiCompletedDriveCount(),plus=false;
try{
plus=localStorage.getItem("diq_plus_active_v1")==="1"||localStorage.getItem("diq_founding_driver_v1")==="1";
}catch(e){
}return n>=5&&!plus;
}function mdiOpenPlusUpgrade(){
  // Web customers use the verified Shopify monthly subscription landing page.
  // The native app keeps the Apple StoreKit purchase bridge.
  if(window.DriveIQNative && typeof window.DriveIQNative.entitlement==="function"){
    window.location.href="driveiq://purchase?productId=com.loveforlocals.driveiq.plus.monthly&source=my_drive_iq";
  }else{
    window.location.assign("/pages/web-upgrades");
  }
}function mdiBindTier(){
var b=byId("mdiTierUpgrade");
if(b){
b.onclick=function(){ mdiOpenPlusUpgrade(); };
}
window.addEventListener("driveIQEntitlementChanged",function(e){
var d=e&&e.detail?e.detail:{
};
if(typeof d.effectivePlus==="boolean"){
try{
localStorage.setItem("diq_plus_active_v1",d.effectivePlus?"1":"0");
}catch(err){
}
}mdiRenderTier();
},false);
document.addEventListener("click",function(event){
if(!mdiPremiumLocked()){
return;
}var n=event.target;
while(n&&n!==document){
if(n.id==="mdiSilverSave"){
event.preventDefault();
event.stopPropagation();
if(typeof event.stopImmediatePropagation==="function"){
event.stopImmediatePropagation();
}if(b){b.click();}else{mdiOpenPlusUpgrade();}
return;
}n=n.parentNode;
}
},true);
window.addEventListener("pageshow",mdiRenderTier,false);
window.addEventListener("focus",mdiRenderTier,false);
mdiRenderTier();
}function mdiApplyPromoEntitlement(data){
var d=data||{
},m=byId("mdiPromoMsg"),i=byId("mdiPromoInput");
if(d.effectivePlus===true){
try{
localStorage.setItem("diq_plus_active_v1","1");
if(d.promoPlan){
localStorage.setItem("diq_promo_plan_v1",String(d.promoPlan));
}if(d.promoExpiresAt){
localStorage.setItem("diq_promo_expires_at_v1",String(d.promoExpiresAt));
}
}catch(e){
}if(m){
var label=clean(d.promoPlan||"Drive IQ Plus"),exp=clean(d.promoExpiresAt||""),expText="";
try{
if(exp){
expText=" through "+new Date(exp).toLocaleDateString();
}
}catch(e2){
}m.textContent="✓ "+label+" activated"+expText+".";
m.style.color="#54ffbd";
}if(i){
i.value="";
}mdiRenderTier();
return true;
}return false;
}function bindPromo(){
var b=byId("mdiPromoBtn"),i=byId("mdiPromoInput"),m=byId("mdiPromoMsg");
if(!b||!i)return;
b.onclick=function(){
var c=clean(i.value).toUpperCase().replace(/\s+/g,"");
if(!c){
if(m){
m.textContent="Enter a promo code.";
m.style.color="rgba(255,255,255,.65)";
}return;
}if(m){
m.textContent="Checking code…";
m.style.color="rgba(255,255,255,.65)";
}b.disabled=true;
try{
if(window.DriveIQNative&&typeof window.DriveIQNative.entitlement==="function"){
var result=window.DriveIQNative.entitlement("activatePromoCode",{
code:c,source:"my-drive-iq"
});
if(result===false){
b.disabled=false;
if(m){
m.textContent="Promo verification is not connected to the Drive IQ app.";
m.style.color="#ff9a9a";
}return;
}if(m){
m.textContent="Verifying promo code…";
}window.setTimeout(function(){
b.disabled=false;
if(m&&m.textContent==="Verifying promo code…"){
m.textContent="Still waiting for Drive IQ to verify the code.";
}
},8000);
return;
}
}catch(e){
b.disabled=false;
if(m){
m.textContent="Promo verification failed.";
m.style.color="#ff9a9a";
}return;
}b.disabled=false;
if(m){
m.textContent="Promo verification is not connected to the Drive IQ app.";
m.style.color="#ff9a9a";
}
};
}function bindPromoResult(){
window.addEventListener("driveIQEntitlementChanged",function(e){
var d=(e&&e.detail)||{
},m=byId("mdiPromoMsg"),b=byId("mdiPromoBtn");
if(b){
b.disabled=false;
}if(d.status==="promo"&&d.effectivePlus===true){
mdiApplyPromoEntitlement(d);
return;
}if(d.reason==="promo-activated"&&d.effectivePlus===true){
mdiApplyPromoEntitlement(d);
return;
}if(d.status==="promo_rejected"||d.reason==="invalid-promo-code"||d.reason==="empty-promo-code"){
if(m){
m.textContent=d.reason==="empty-promo-code"?"Enter a promo code.":"That promo code is not valid.";
m.style.color="#ff9a9a";
}return;
}if(d.status==="promo_expired"||d.reason==="expired-promo-code"){
if(m){
m.textContent="That promo code has expired.";
m.style.color="#ff9a9a";
}return;
}
});
}(function(){
var i=byId("mdiSilverImage"),b=byId("mdiSilverSave"),m=byId("mdiSilverStatus");
if(!i||!b)return;
function check(){
if(i.naturalWidth){
b.disabled=false;
b.textContent="Save Silver Sedan";
m.textContent="Shopify image loaded. Save this vehicle for Drive Mode.";
}else{
b.disabled=true;
b.textContent="Image unavailable";
m.textContent="Check the Shopify file URL.";
}
}i.onload=check;
i.onerror=check;
if(i.complete)check();
b.onclick=function(){
if(!i.naturalWidth)return;
try{
localStorage.setItem("diq_vehicle_3d_type_v1","sedan");
localStorage.setItem("diq_vehicle_3d_color_v1","silver");
localStorage.setItem("diq_vehicle_3d_url_v1",i.src);
b.textContent="✓ Silver Sedan Saved";
m.textContent="Saved. Drive Mode integration comes next.";
}catch(e){
m.textContent="Save unavailable on this device.";
}
};
})();
var travelPreview=byId("mdiTravelIQPreview");
if(travelPreview){
travelPreview.onclick=function(){
travelPreview.textContent="Travel IQ is coming to My Drive IQ";
};
}exposeSkinBridge();
syncThemes();
syncMarkers();
bindBack();
installGoDriveShortcut();
ensureVoiceCard();
mdiBindTier();
bindPromo();
bindPromoResult();
bindThemes();
bindMarkers();
bindVoice();
syncThemes();
syncMarkers();
syncVoice();
rotateHeroCopy();
waitForDriveIQ(render);
window.addEventListener("pageshow",render,false);
window.addEventListener("focus",render,false);
window.addEventListener("driveiq:themechange",syncThemes,false);
window.addEventListener("diqVoiceChanged",syncVoice,false);
window.addEventListener("driveiq:markerchange",syncMarkers,false);
})();
